//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalProgramFundsRemainingWidget = ({ count }: { count: string | number }) => {
  return <StatCard title='Total Program Funds Remaining' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalProgramFundsRemainingWidget;
